<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h2 class="title_mo">Quản lý cửa hàng</h2>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search search_css" @submit="submitForm">
          <div class="form-group">
            <Select2
              v-model="filters.mcOwnerId"
              :options="mcOwnerOptions"
              :settings="ownerSettings"
              placeholder="MO"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.mcAccId"
              :options="mcAccOptions"
              :settings="accountSettings"
              placeholder="MA"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Tên cửa hàng/Email/SĐT"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessRegionCode"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              placeholder="Vùng kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.businessProvinceCode"
              :options="dataProvince"
              :disabled="!filters.businessRegionCode || filters.businessRegionCode === '0'"
              placeholder="Tỉnh/Thành phố kinh doanh"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.regionCode"
              :options="dataConfigRegionMC"
              @change="queryMcProvince($event)"
              placeholder="Vùng cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.provinceCode"
              :options="dataProvinceMC"
              placeholder="Tỉnh/Thành phố cửa hàng"
              :disabled="!filters.regionCode || filters.regionCode === '0'"
              @change="getMcDistrict($event)"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.districtCode"
              :options="dataDistrict"
              placeholder="Quận/Huyện cửa hàng"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.managerStaffId" :options="listUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :options="listUser"
              placeholder="Nhân viên chăm sóc"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeAssign"
              :options="optionsTypeAssign"
              placeholder="Trạng thái gán"
            />
          </div>
          <!-- <div class="form-group">
            <input type="text" v-model.trim="maSearch" class="form-control f12 hc-37 text-search"
              placeholder="Tìm kiếm Tài khoản" @input="searchMcAcc" :debounce="500" autocomplete="off" />
          </div> -->
          <div class="form-group">
            <Select2
              v-model="filters.status"
              :options="listStatus"
              placeholder="Trạng thái cửa hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.type_ma"
              :options="optionsMa"
              placeholder="Loại MC"
              :settings="{ multiple: true }"
            />
          </div>
          <div class="form-group form-group-action search_css">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
          <div class="form-group form-group-action search_css">
            <button
              v-if="hasAssignPermission"
              type="button"
              @click="onAssignHandle"
              class="btn btn-outline-info mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Tạo phiếu gán"
              :disabled="!hasCheckeds"
            >
              <span>&nbsp;</span>Tạo phiếu gán
            </button>
            <button
              type="button"
              @click="createStore"
              class="btn btn-outline-info hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Thêm"
            >
              <span>&nbsp;</span>Thêm
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header list_total">
                <TotalCountCheck :totals="totalCount" :data="totals" />
              </div>
              <div
                v-show="idsSelected.length"
                @click="onClearSelect"
                class="text-nowrap ml-auto text-primary cursor-pointer clean-select"
                v-b-tooltip.hover
                :title="`Click để bỏ chọn, chọn tối đa ${maxtSelect}`"
              >
                Đã chọn:
                <strong class="text-danger">{{
                  idsSelected.length.toLocaleString('vi-VN')
                }}</strong>
              </div>
            </div>
            <b-table
              bordered
              hover
              head-variant="light"
              fixed
              show-empty
              responsive
              sticky-header
              :items="dataTable"
              :fields="fields"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #cell(mobile)="{ value }">
                {{ value | encryptPhone }}
              </template>

              <template #head(checkbox)>
                <b-form-checkbox
                  v-model="selectAll"
                  @change="toggleSelectAll"
                  :disabled="isLoading"
                />
              </template>
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox v-model="item.checked" @change="toggleSelectOne(item)" />
              </template>

              <template #cell(index)="{ index }">
                {{
                  pagination.page > 1
                    ? index + 1 + pagination.limit * (pagination.page - 1)
                    : index + 1
                }}
              </template>

              <template #cell(store)="{ item }">
                <!-- <div><span class="text-primary">{{ item.id }}</span></div> -->
                <div>
                  <b-link :href="`/customer-support/store/${item.id}`" target="_blank">{{
                    item.storeName ?? item.email
                  }}</b-link>
                </div>
                <div>
                  <!-- getAdressByCode(item)  -->
                  {{ getAdressByCode(item) }} <br />
                  <b-icon icon="geo-alt"></b-icon>
                  <strong
                    class="text-primary"
                    style="cursor: pointer"
                    @click="showMapModal(item.latitude, item.longitude, getAdressByCode(item))"
                    >{{ item.address }}</strong
                  >
                </div>
              </template>

              <template #cell(account)="{ item }">
                <!-- <div><span class="text-primary">{{ item?.merchantAccount?.id }}</span></div> -->
                <div>
                  <b-link
                    :href="`/customer-support/account/${item?.merchantAccount?.id}`"
                    target="_blank"
                    >{{ item?.merchantAccount?.accountName }}</b-link
                  >
                </div>
                <div v-if="item?.merchantAccount?.businessRegistrationAddress">
                  <b-icon icon="geo-alt"></b-icon>
                  <strong
                    class="text-primary"
                    style="cursor: pointer"
                    @click="openInGoogleMaps(item?.merchantAccount?.businessRegistrationAddress)"
                    >{{ item?.merchantAccount?.businessRegistrationAddress }}</strong
                  >
                </div>
              </template>

              <template #cell(staff)="{ item }">
                <div v-if="getMainStaff(item)">
                  <span class="text-muted">Chính</span>:
                  <b-link :href="`/staff/detail/?id=${getMainStaff(item).staffId}`" target="_blank">
                    {{ getMainStaff(item).staffName }}</b-link
                  >
                </div>
                <div v-if="getSecondStaff(item)">
                  <span class="text-muted">Phụ</span>:
                  <!-- <span v-html="truncatedText(item)"></span> -->
                  <span v-for="(staff, index) in getSecondStaffArr(item)" :key="staff.staffId">
                    <a
                      v-if="index < 3"
                      style="cursor: pointer"
                      :href="`/staff/detail/?id=${staff.staffId}`"
                      target="_blank"
                    >
                      {{
                        `${staff.staffName}${index < getSecondStaffArr(item).length - 1 ? '; ' : ''}`
                      }}
                    </a>
                  </span>
                  <span
                    v-if="remainingCount(getSecondStaff(item))"
                    v-b-tooltip.hover="{ customClass: 'tooltip-class' }"
                    v-b-tooltip.hover.html="tooltipContent(item)"
                    style="cursor: pointer"
                  >
                    ...{{ remainingCount(getSecondStaff(item)) }}
                  </span>
                </div>
              </template>

              <template #cell(status)="{ item }">
                <div class="text-center" v-if="item.status || item.status != 'null'">
                  <span :class="`badge ${getStatusClass(item.status)}`">{{
                    getStatusName(item.status)
                  }}</span>
                </div>
              </template>

              <template #cell(typeSconMa)="{ item }">
                <div class="text-center">
                  <span>
                    {{ getStatusNameMC(item.typeSconMa) }}
                  </span>
                </div>
              </template>

              <template #cell(tele)="{ item }">
                <div><b-icon icon="person"></b-icon> {{ item?.tele?.name }}</div>
                <div><b-icon icon="envelope"></b-icon> {{ item?.tele?.email }}</div>
                <div><b-icon icon="phone"></b-icon> {{ item?.tele?.mobile }}</div>
              </template>

              <template #cell(summary)="{ item }">
                <div>User: 3</div>
                <div>thiết bị: {{ item?.device }}</div>
              </template>

              <template #head(actions)="{ label }">
                <div>{{ label }}</div>
              </template>

              <template #cell(actions)="{ item }">
                <div style="padding-left: 10px">
                  <b-link
                    :href="`/customer-support/store/${item.id}`"
                    target="_blank"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <img
                      src="@/assets/img/circle-three-dots.svg"
                      alt="Circle with Three Dots"
                      style="width: 15px; height: 15px"
                    />
                    Chi tiết
                  </b-link>
                  <br />
                  <b-link
                    target="_blank"
                    :to="`/customer-support/store/${item.id}/edit`"
                    style="color: #0056f6"
                    size="sm"
                  >
                    <i class="bx bx-edit-alt" style="width: 15px; height: 15px"></i>
                    Cập nhật
                  </b-link>
                  <br />
                  <b-link
                    :href="`/customer-support/store/${item.id}/history-assign`"
                    style="color: #0056f6"
                    size="sm"
                    target="_blank"
                    ><b-icon icon="list-ul"></b-icon> Lịch sử gán CS</b-link
                  >
                  <br />
                  <b-link
                    :href="`/customer-support/store/${item.id}/history-remove-assign`"
                    style="color: #0056f6"
                    size="sm"
                    target="_blank"
                    ><b-icon icon="list-task"></b-icon> Lịch sử gỡ gán CS</b-link
                  >
                  <br />
                  <b-link
                    :to="{
                      path: `/customer-support/task/`,
                      query: {
                        storeId: item.id,
                        storeName: item.storeName ?? '',
                      },
                    }"
                    style="color: #0056f6"
                    size="sm"
                    target="_blank"
                    ><b-icon icon="card-list"></b-icon> Lịch sử chăm sóc</b-link
                  >
                </div>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="totalCount"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <GmapMap
          :center="{ lat: latitude, lng: longitude }"
          :zoom="12"
          map-type-id="terrain"
          style="width: 100%; height: 500px"
        >
          <gmap-marker :position="{ lat: latitude, lng: longitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal ref="map-address" centered hide-footer hide-header size="lg" style="z-index: 500">
      <div>
        <iframe loading="lazy" :src="url" height="500" style="width: 100%" frameborder="0"></iframe>
      </div>
    </b-modal>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import { SearchByCode } from '@/services/customer-support/location'
  import { List } from '@/services/customer-support/store'
  import { List as OwnerList } from '@/services/customer-support/merchant-owner'
  import { Search } from '@/services/customer-support/account'
  import { showMess } from '@/config/utils'
  import TotalCountCheck from '@/components/cskh/Counts.vue'
  import gzip from 'gzip-js'

  const maxtSelect = 200

  export default {
    components: {
      TotalCountCheck,
    },
    data() {
      return {
        filters: {
          textSearch: '',
          regionCode: '',
          provinceCode: '',
          districtCode: '',
          businessRegionCode: '',
          businessProvinceCode: '',
          managerStaffId: '',
          staffId: '',
          typeAssign: '',
          status: '',
          mcAccId: '',
          mcOwnerId: '',
          type_ma: [],
        },
        latitude: 0.0,
        longitude: 0.0,
        url: '',
        isLoading: true,
        selectAll: false,
        checkedItems: [],
        dataConfigRegion: [],
        dataConfigRegionMC: [],
        dataProvinceMC: [],
        dataProvince: [],
        dataDistrict: [],
        dataDistrictName: [],
        dataConfigMcc: [],
        dataManager: [],
        listUser: [],
        optionsTypeAssign: [],
        optionsMa: [
          { id: 0, text: 'Tất cả' },
          { id: 'MA_THE', text: 'MC thẻ' },
          { id: 'ONBOARD_QR', text: 'MC chỉ dùng QR' },
          { id: 'MA_ORTHER', text: 'MC khác' },
        ],
        mcAccOptions: [],
        mcOwnerOptions: [],
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        totalCount: 0,
        // config
        dataConfigService: [],
        sourceCreate: Config.sourceCreate,
        localeData: Config.localeData,
        ownershipType: [], // systemConfig.ownershipType,

        listMcType: [
          { id: 0, text: 'Tất cả' },
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_NORMAL', text: 'Merchant thường' },
        ],
        listStatus: [],
        fields: [
          // {
          //   key: 'checkbox',
          //   label: '',
          //   thStyle: 'width: 30px; text-align: center',
          //   sortable: false,
          // },
          {
            key: 'index',
            label: 'STT',
            class: 'text-center',
            thStyle: 'width: 30px; text-align: center',
          },

          // {
          //   key: 'mcAccId',
          //   label: 'Số đăng ký kinh doanh của MA',
          //   sortable: false,
          //   class: 'text-center'
          // },
          // {
          //   key: 'mcAccName',
          //   label: 'Tên MA',
          //   sortable: false,
          //   thStyle: 'min-width: 100px',
          //   tdClass: 'owner_class'
          // },
          {
            key: 'store',
            label: 'Cửa hàng',
            sortable: false,
            thStyle: 'min-width: 100px',
            tdClass: 'owner_class',
          },
          {
            key: 'account',
            label: 'Tài khoản',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          // {
          //   key: 'tele',
          //   label: 'Liên hệ',
          //   sortable: false,
          //   thStyle: 'min-width: 100px',
          //   tdClass: 'address_class'
          // },
          // {
          //   key: 'summary',
          //   label: 'Thống kê',
          //   sortable: false,
          // },
          {
            key: 'staff',
            label: 'NV chăm sóc',
            sortable: false,
            thStyle: 'min-width: 150px, max-width: 200px',
            tdClass: 'td_class',
          },
          {
            key: 'status',
            label: 'Trạng thái',
            sortable: false,
            thStyle: 'min-width: 100px; max-width: 150px;',
            class: 'text-center ',
          },
          {
            key: 'typeSconMa',
            label: 'Loại MC',
            sortable: false,
            thStyle: 'min-width: 100px',
            class: 'text-center',
          },
          {
            key: 'actions',
            label: 'Thao tác',
            sortable: false,
            class: 'text-center',
            thStyle: 'min-width: 80px',
          },
        ],
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        totals: {
          suspend: 0,
          active: 0,
        },
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        tLoadAccount: undefined,
        accountSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const queryString = [
                `{textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}'''`,
              ]
              this.filters.mcAccId &&
                queryString.push(`{mcAccountId} == '''${this.filters.mcAccId}'''`)
              if (this.tLoadAccount) {
                clearTimeout(this.tLoadAccount)
              }
              this.tLoadAccount = setTimeout(() => {
                Search({
                  showFields: ['id', 'accountName', 'email', 'businessRegistrationNumber'],
                  limit: 10,
                  page: 1,
                  queryString: queryString.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item?.id,
                          text: item?.accountName ?? item?.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        tLoadOwner: undefined,
        ownerSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }
              const keySearch = txtSearch ?? ''
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                OwnerList({
                  limit: 10,
                  page: 1,
                  keyWord: keySearch,
                  sort: {
                    direction: 'DESC',
                    properties: ['createdDate'],
                  },
                })
                  .then(res => {
                    success({
                      results:
                        res.data.list?.map(item => {
                          return {
                            id: item?.id,
                            text: (item?.ownerName || item?.masterName) ?? item?.email,
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },

        // multiple select row
        idsSelected: [],
        maxtSelect,
      }
    },
    filters: {
      transfromRegion(data, dataConfigRegion) {
        const dataReturn = dataConfigRegion.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    async mounted() {
      await this.configSystem()
      if (this.dataPermission.includes('CNPS_CSS_STORE_LIST')) {
        await this.getRegions()
        await this.getListStaffBySuperior()
        await this.buildQuery()
        await this.getMcRegions()
        await this.getManager()
        this.isLoading = false
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },

    created() {
      const queries = this.$router.currentRoute.query
      if (queries.moId && queries.moName) {
        this.mcOwnerOptions = [
          {
            id: queries.moId,
            text: queries.moName,
          },
        ]
        this.filters.mcOwnerId = queries.moId
      }
      if (queries.maId && queries.maName) {
        this.mcAccOptions = [
          {
            id: queries.maId,
            text: queries.maName,
          },
        ]
        this.filters.mcAccId = queries.maId
      }
      if (queries.status) {
        this.filters.status = queries.status
      }

      if (this.hasAssignPermission) {
        this.fields.unshift({
          key: 'checkbox',
          label: '',
          sortable: false,
          thStyle: 'width: 30px; text-align: center',
        })
      }
    },
    computed: {
      hasAssignPermission() {
        return this.dataPermission.includes('CNPS_CSS_ASSIGN_ORDER_CREATE')
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStatusName() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getStatusClass() {
        return status => {
          const objStatus = this.listStatus.find(s => s.id === status)
          return objStatus ? objStatus.bgColor : 'badge-primary'
        }
      },
      getStatusNameMC() {
        return status => {
          const objStatus = this.optionsMa.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getMainStaff() {
        return maInfo => {
          return maInfo.staffAssigns && maInfo.staffAssigns.length > 0
            ? maInfo.staffAssigns.find(uInfo => uInfo.configType === 'MAIN')
            : undefined
        }
      },
      getSecondStaff() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          if (usersInfo) {
            return usersInfo
              .reduce((arr, userInfo) => {
                arr.push(userInfo.staffName)
                return arr
              }, [])
              .join(', ')
          }
          return ''
        }
      },
      getSecondStaffArr() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          return usersInfo
        }
      },
      truncatedText() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          if (usersInfo) {
            const parts = usersInfo.reduce((arr, userInfo) => {
              arr.push({
                id: userInfo.staffId,
                name: userInfo.staffName,
              })
              return arr
            }, [])
            if (parts.length > 3) {
              return parts
                .slice(0, 3)
                .map(item => {
                  return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name}</a>`
                })
                .join(', ')
            }
            return parts
              .map(item => {
                return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name}</a>`
              })
              .join(', ')
          }
          return ''
        }
      },
      remainingCount() {
        return maInfo => {
          const parts = maInfo.split(', ')
          if (parts.length > 3) {
            return `+${parts.length - 3}`
          }
          return ''
        }
      },
      tooltipContent() {
        return maInfo => {
          const usersInfo =
            maInfo.staffAssigns && maInfo.staffAssigns.length > 0
              ? maInfo.staffAssigns.filter(uInfo => uInfo.configType === 'SECOND')
              : []
          if (usersInfo) {
            const parts = usersInfo.reduce((arr, userInfo) => {
              arr.push({
                id: userInfo.staffId,
                name: userInfo.staffName,
              })
              return arr
            }, [])
            if (parts.length > 3) {
              return parts
                .slice(3)
                .map(item => {
                  return `<a style="cursor: pointer;" href='/staff/detail/?id=${item.id}' target="_blank">${item.name}</a>`
                })
                .join('<br>')
            }
          }
          return ''
        }
      },
      hasCheckeds() {
        // return this.dataTable.some(row => row.checked)
        return this.idsSelected.length > 0
      },
    },
    methods: {
      openInGoogleMaps(address) {
        // const url = `https://www.google.com/maps/search/api=1&query=${encodeURIComponent(address)}`;
        // window.open(url, '_blank');
        const url = `https://maps.google.com/maps?q=${address}&output=embed`
        this.url = url
        this.$refs['map-address'].show()
      },
      openInGoogleMapsLatLng(lat, lng) {
        const url = `https://www.google.com/maps?q=${lat},${lng}`
        window.open(url, '_blank')
      },
      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.refreshTable()
      },
      refreshTable() {
        this.buildQuery()
      },
      // nút bỏ lọc
      async clearSearch() {
        this.selectAll = false
        this.pagination.page = 1
        this.filters.textSearch = ''
        this.search = ''
        this.filters.regionCode = ''
        this.filters.provinceCode = ''
        this.filters.districtCode = ''
        this.filters.businessRegionCode = ''
        this.filters.businessProvinceCode = ''
        this.filters.managerStaffId = ''
        this.filters.typeAssign = ''
        this.filters.status = ''
        this.filters.mcAccId = ''
        this.filters.mcOwnerId = ''
        this.filters.staffId = ''
        this.filters.type_ma = []
        this.dataProvince = []
        this.dataProvinceMC = []
        this.dataDistrict = []
        await this.buildQuery()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        const textSearch = this.filters.textSearch?.trim()
        textSearch && conditions.push(`{textSearch} LIKE '''${textSearch}'''`)
        // this.filters.mcLvl && this.filters.mcLvl !== '0' && conditions.push(`{mcLvl} == '''${this.filters.mcLvl}'''`)
        this.filters.businessRegionCode &&
          this.filters.businessRegionCode !== '0' &&
          (conditionsMap.businessRegionCode = this.filters.businessRegionCode)
        this.filters.businessProvinceCode &&
          this.filters.businessProvinceCode !== '0' &&
          (conditionsMap.businessProvinceCode = this.filters.businessProvinceCode)

        this.filters.managerStaffId &&
          this.filters.managerStaffId !== '0' &&
          (conditionsMap.managerStaffId = this.filters.managerStaffId)
        // this.filters.mainBusinessMcc && this.filters.mainBusinessMcc !== '0' && conditions.push(`{mainBusinessMcc} == '''${this.filters.mainBusinessMcc}'''`)
        // this.filters.ownershipType && this.filters.ownershipType !== '0' && conditions.push(`{ownershipType} == '''${this.filters.ownershipType}'''`)
        // this.filters.assignState && (conditionsMap.assignState = this.filters.assignState)
        this.filters.status &&
          this.filters.status !== '0' &&
          conditions.push(`{storeStatus.storeStatus} == '''${this.filters.status}'''`)

        this.filters.regionCode &&
          this.filters.regionCode !== '0' &&
          conditions.push(`{regionCode} == '''${this.filters.regionCode}'''`)
        this.filters.provinceCode &&
          this.filters.provinceCode !== '0' &&
          conditions.push(`{provinceCode} == '''${this.filters.provinceCode}'''`)
        this.filters.districtCode &&
          this.filters.districtCode !== '0' &&
          conditions.push(`{districtCode} == '''${this.filters.districtCode}'''`)
        this.filters.mcAccId &&
          this.filters.mcAccId !== '0' &&
          conditions.push(`{mcAccountId} == '''${this.filters.mcAccId}'''`)
        this.filters.mcOwnerId &&
          this.filters.mcOwnerId !== '0' &&
          conditions.push(`{merchantOwnerId} == '''${this.filters.mcOwnerId}'''`)
        if (this.filters.type_ma && this.filters.type_ma.length > 0) {
          const typeValues = this.filters.type_ma.map(t => `'''${t}'''`).join(', ')
          conditions.push(`{type_ma} IN [${typeValues}]`)
        }

        if (this.filters.staffId && this.filters.staffId !== '0') {
          conditionsMap.staffId = this.filters.staffId
        }
        this.filters.typeAssign && (conditionsMap.typeAssign = this.filters.typeAssign)

        this.pagination.queryString = conditions.join(' AND ')
        await this.loadData(conditionsMap)
      },
      async loadData(conditionsMap = {}) {
        try {
          this.isLoading = true
          const searchQuery = {
            countStatus: true,
            showMerchantAccount: true,
            showStaffAssign: true,
            limit: this.pagination.limit,
            page: this.pagination.page,
            queryString: this.pagination.queryString,
            ...conditionsMap,
            sort: {
              direction: this.pagination.sortType,
              properties: [this.pagination.sortField],
            },
          }
          const res = await List(searchQuery)
          if (res.data.listData) {
            this.dataTable = res.data.listData.map(el => {
              return {
                ...el,
                checked: this.idsSelected.includes(el.id),
              }
            })
          } else {
            this.dataTable = []
          }
          this.selectAll = false
          this.pagination.total = res.data.totalCount ?? 0
          this.totalCount = res.data.totalCount ?? 0
          if (res.data.listCountStatus) {
            this.totals = res.data.listCountStatus
              .filter(item => item.status)
              .sort((a, b) => a.status.localeCompare(b.status))
              .reduce((acc, item) => {
                const status = acc.find(s => s.status === item.status)
                if (status) {
                  status.count += item.count
                } else {
                  const statusObj = this.listStatus.find(list => list.id == item.status)
                  acc.push({
                    status: statusObj?.text || item.status,
                    status_class: statusObj?.class ?? 'text-primary',
                    count: item.count,
                  })
                }
                return acc
              }, [])
          } else {
            this.totals = []
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      async onChangeAccount(e) {
        await this.loadDataContact(e)
      },
      async loadDataContact(e) {
        try {
          // this.mcAccId = ''
          this.mcAccOptions = []
          const res = await Search({
            showFields: ['id', 'accountName', 'email', 'businessRegistrationNumber'],
            limit: 10,
            page: 1,
            queryString: `{textSearch} LIKE '''${this.mcAccId}'''`,
            sort: {
              direction: 'ASC',
              properties: ['accountName'],
            },
          })
          if (res.result) {
            this.mcAccOptions = res.data.listData.map(item => {
              return {
                id: item?.id,
                text: item?.accountName ?? item?.email,
              }
            })
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },
      showMapModal(lat, long, address) {
        if (lat && long) {
          this.latitude = Number.isInteger(this.latitude) ? lat : parseFloat(lat)
          this.longitude = Number.isInteger(this.longitude) ? long : parseFloat(long)
          this.$refs['modal-map'].show()
        } else {
          this.url = `https://maps.google.com/maps?q=${address}&output=embed`
          this.$refs['map-address'].show()
        }
      },
      getAdressByCode(item) {
        const addressArr = []
        if (item.districtName) {
          addressArr.push(item.districtName)
        }
        if (item.provinceName) {
          addressArr.push(item.provinceName)
        }
        if (item.regionName) {
          addressArr.push(item.regionName)
        }
        return addressArr.length > 0 ? addressArr.join(', ') : item.address
      },
      async submitForm(event) {
        event.preventDefault()
        this.selectAll = false
        this.pagination.page = 1
        this.buildQuery()
      },
      // page
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },
      onDetailClick(item) {
        this.$router.push(`/customer-support/store/${item.id}`)
      },
      // checkbox
      // onAssignHandle() {
      //   const checkedIds = this.dataTable.reduce((arr, item) => {
      //     item.checked && arr.push(item.id);
      //     return arr;
      //   }, []);
      //   if (checkedIds.length > 0) {
      //     const addParams = {
      //       ids: checkedIds,
      //       level: 'STORE'
      //     };
      //     const random = Math.random()
      //       .toString(36)
      //       .substring(2, 15)
      //     localStorage.setItem(random, JSON.stringify(addParams));
      //     this.$router.push(`/customer-support/add-staff/${random}`);
      //   }
      // },
      // onAssignHandle() {
      //   const checkedIds = this.dataTable.reduce((arr, item) => {
      //     item.checked && arr.push(item.id);
      //     return arr;
      //   }, []);
      //   if (checkedIds.length > 0) {
      //     const gzipData = gzip.zip(checkedIds.join(','), {
      //       level: 9,
      //     });
      //     const encodedString = btoa(String.fromCharCode(...gzipData));
      //     this.$router.push({ path: `/customer-support/add-staff/STORE`, query: { ids: encodedString } });
      //   }
      // },
      onAssignHandle() {
        const checkedIds = this.idsSelected
        if (checkedIds.length > 0) {
          const gzipData = gzip.zip(checkedIds.join(','), {
            level: 9,
          })
          const encodedString = btoa(String.fromCharCode(...gzipData))
          this.$router.push({
            path: `/customer-support/add-staff/STORE`,
            query: { ids: encodedString },
          })
        }
      },
      toggleSelectAll() {
        // this.dataTable.forEach(item => {
        //   item.checked = this.selectAll;
        // });
        const value = this.selectAll
        for (const item of this.dataTable) {
          item.checked = value
          const id = item.id
          const index = this.idsSelected.indexOf(id)
          index >= 0 && this.idsSelected.splice(index, 1)
          if (value) {
            !this.idsSelected.includes(id) && this.idsSelected.push(id)
          }
        }
        this.cleanSelectIfOver()
      },
      toggleSelectOne(item) {
        const id = item.id
        const index = this.idsSelected.indexOf(id)
        index >= 0 && this.idsSelected.splice(index, 1)
        if (item.checked) {
          !this.idsSelected.includes(id) && this.idsSelected.push(id)
        }
        this.selectAll = this.dataTable.every(item => item.checked)
        this.cleanSelectIfOver()
      },
      onClearSelect() {
        this.idsSelected = []
        this.selectAll && (this.selectAll = false)
        this.dataTable.forEach(item => {
          item.checked && (item.checked = false)
        })
      },
      cleanSelectIfOver() {
        this.idsSelected.length > maxtSelect &&
          (() => {
            this.idsSelected = this.idsSelected.slice(-maxtSelect)
          })()
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegionsConfig()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        try {
          this.filters.businessProvinceCode = ''
          this.dataProvince = []
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy vùng mc
      async getMcRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegionMC = data.data.map(e => {
            return {
              id: e.code,
              text: e.name,
              idRegion: e.id,
            }
          })
          this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      // lấy tỉnh, tp mc
      async queryMcProvince(e) {
        try {
          this.filters.provinceCode = ''
          this.filters.districtCode = ''
          const data = await StaffService.getProvinceRegion({
            regionId: [this.dataConfigRegionMC.find(s => s.id === e).idRegion],
          })
          if (data.data.length > 0) {
            this.dataProvinceMC = data.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
            this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {}
      },
      // lấy quận mc
      async getMcDistrict(event) {
        this.filters.districtCode = ''
        const data = await SearchByCode({ code: event })
        if (data.data.length > 0) {
          this.dataDistrict = data.data
            .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
            .map(e => {
              return {
                id: e.locationCode,
                text: e.localName,
              }
            })
        }
        this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
      },
      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // Lấy quản lý
      async getManager() {
        try {
          const data = await StaffService.superiors()
          if (data.success) {
            this.dataManager = data.data.map(e => {
              return {
                id: e.id,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.dataManager.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // lấy ngành hàng và dịch vụ
      configSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              // this.ownershipType = data.data.ownershipType.map(item => {
              //   return {
              //     id: item.code,
              //     text: item.name
              //   }
              // })
              // this.ownershipType.unshift({ id: "0", text: 'Tất cả' })
              // this.dataConfigService = data.data.services.map(e => {
              //   return {
              //     id: e.code,
              //     text: e.name
              //   }
              // })
              // this.dataConfigService.unshift({ id: '0', text: 'Tất cả' })
              // this.getListService()
              // this.dataConfigMcc = data.data.businessFields.map((e) => {
              //   return {
              //     id: e.code,
              //     text: e.name
              //   }
              // })
              // this.dataConfigMcc.unshift({ id: '0', text: 'Tất cả' })
              this.optionsTypeAssign = data.data.typeAssign.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                }
              })
              this.listStatus = data.data.storeStatus.map(item => {
                return {
                  id: item.code,
                  text: item.name,
                  name: item.name,
                  bgColor: item.bgColor,
                  class: item?.class ?? 'text-primary',
                }
              })
            }
          })
          .catch(error => console.error(error))
      },
      // async getListService() {
      //   try {
      //     const response = await SalesManagerService.getGroupService({})
      //     if (response.code === 1000) {
      //       this.dataGroupService = response.data.groupService
      //       const data = this.dataGroupService.filter((e) => e.service === 'SELL')
      //       if (data[0].detail.length > 0) {
      //         this.dataConfigService = data[0].detail.map((e) => {
      //           return {
      //             id: e.code,
      //             text: this.serviceTypes(e.name)
      //           }
      //         })
      //       }
      //       // ListState
      //       this.listStateSearch = [
      //         { id: '0', text: 'Tất cả' },
      //         ...this.listState
      //       ]
      //     }
      //   } catch (error) {
      //     console.log(error)
      //   }
      // },
      // serviceTypes(itemm) {
      //   const listServiceTypes = Config.listServiceTypes
      //   return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      // },

      createStore() {
        let router = '/customer-support/store/create'
        if (this.$route.query.maId) {
          router = `/customer-support/store/create?maId=${this.$route.query.maId}`
        }
        this.$router.push(router)
      },
    },
  }
</script>
<style scoped>
  .total_check {
    /* margin: 5px; */
    /* text-align: center; */
    display: flex;
    text-align: center;
  }

  .total_label {
    color: #8a9298;
    font-size: 14px;
  }

  .total_field {
    font-size: 20px;
  }
</style>
<style>
  .td_class {
    min-width: 150px;
    max-width: 200px;
  }

  .time_class {
    min-width: 100px;
    max-width: 150px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .tooltip-class .tooltip-inner {
    background-color: rgb(253, 253, 253);
    color: #319db5;
    text-align: left;
    max-height: 150px;
    max-width: 200px;
    overflow-y: auto;
    border: 1px solid;
  }

  .b-table tbody tr {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.06px;
    text-align: left;
  }

  .b-table thead tr {
    font-size: 13px;
    font-weight: 500;
    line-height: 15.23px;
    text-align: left;
  }

  .title_mo {
    font-size: 20px;
    font-weight: 400;
    line-height: 23.44px;
    text-align: left;
  }

  .list_total {
    font-size: 13px;
    font-weight: 400;
    line-height: 15.23px;
    text-align: left;
  }

  .search_css {
    font-size: 12px;
    font-weight: 400;
    line-height: 14.06px;
    text-align: left;
  }
</style>
<style>
  .address_class {
    min-width: 100px;
    max-width: 220px;
  }

  .owner_class {
    min-width: 120px;
    max-width: 220px;
  }

  .business_type_class {
    min-width: 100px;
    max-width: 180px;
  }

  .status_class {
    min-width: 100px;
    max-width: 120px;
  }

  .select2-dropdown {
    z-index: 1030 !important;
  }

  .clean-select {
    &:hover {
      text-decoration: line-through;
    }
  }
</style>
